import { render } from "./QuickNavGridShell.vue?vue&type=template&id=f153e354&scoped=true"
import script from "./QuickNavGridShell.vue?vue&type=script&lang=js"
export * from "./QuickNavGridShell.vue?vue&type=script&lang=js"

import "./QuickNavGridShell.vue?vue&type=style&index=0&id=f153e354&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f153e354"]])

export default __exports__